<div class="d-flex justify-content-end mb-4">
  <mdb-form-control>
    <input mdbInput type="text" class="form-control" id="search-input" (keyup)="search($event)" />
    <label mdbLabel class="form-label" for="search-input">Buscar Apps</label>
  </mdb-form-control>
  <button mdbRipple class="btn btn-primary btn-sm ms-3" (click)="openModal('add')">
    <i class="fa fa-plus"></i>
  </button>
</div>
<hr />
<div class="datatable table-editor mt-4">
  <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
    [dataSource]="dataSource" [sort]="sort" [pagination]="pagination">
    <thead class="datatable-header">
      <tr>
        <th *ngFor="let header of headers" [mdbTableSortHeader]="header.field" [disableSort]="header.disableSort"
          scope="col">
          {{ header.label | titlecase }}
        </th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody class="datatable-body" *ngIf="!loading">
      <tr *ngFor="let data of table.data; let index = index" scope="row">
        <td style="min-width: 250px; max-width: 250px">
          {{ data.NAME }}
        </td>
        <td style="min-width: 250px; max-width: 250px">
          <!-- <mdb-file-upload
            [defaultPreview]="data.LOGO"
          ></mdb-file-upload>--> <img [src]="data.LOGO">
        </td>
        <td style="min-width: 100px; max-width: 100px">
          <span *ngIf="data.ACTIVE === '1'">
            <i class="fa fa-check text-success"></i>
          </span>
          <span *ngIf="data.ACTIVE !== '1'">
            <i class="fa fa-circle text-danger"></i>
          </span>
        </td>

        <td>
          <button class="me-2 m-0 p-0 shadow-0 btn btn-lg text-dark edit-button" (click)="openModal('edit', data)">
            <i class="far fa-edit"></i>
          </button>
          <button class="m-0 p-0 shadow-0 btn btn-lg text-dark delete-button" (click)="onDeleteClick(data)">
            <i class="far fa-trash-alt"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <ng-container *ngIf="loading">
    <div class="datatable-loader bg-light">
      <span class="datatable-loader-inner">
        <span class="datatable-progress bg-primary"></span>
      </span>
    </div>
    <p class="text-center text-muted my-4">Cargando información...</p>
  </ng-container>
  <mdb-table-pagination #pagination [entries]="25" [disabled]="loading"></mdb-table-pagination>
</div>